export default "/kiban/_next/static/images/designDaysShortening-3695799ed7235a9caec8e880578ea4b4.png";